<template>
  <div class="dialog-root">
    <div class="container">
      <el-form ref="formRef" :model="formData" label-width="80px" :rules="rules">
        <el-form-item label="目录名称">
          <el-input v-model="formData.menuName" disabled></el-input>
        </el-form-item>
        <el-form-item label="文件标题" prop="title">
          <el-input
            v-model="formData.title"
            maxlength="30"
            placeholder="请输入 文件标题"
            show-word-limit
          ></el-input>
        </el-form-item>
        <el-form-item label="文件说明" prop="content">
          <el-input
            type="textarea"
            placeholder="请输入 文件说明"
            :autosize="{ minRows: 2, maxRows: 4 }"
            v-model="formData.content"
            maxlength="200"
            show-word-limit
          ></el-input>
        </el-form-item>
        <el-form-item label="文件上传" prop="attachList">
          <VUpload
            :fileList.sync="formData.attachList"
            :limit="1"
            :max="256 * 1024 * 1024"
            :disabled="dialogType == 'view'"
          />
        </el-form-item>
      </el-form>
    </div>
    <!-- 按钮占位区域 -->
    <div class="placeholder"></div>
    <!-- 底部操作按钮 -->
    <div class="btn">
      <el-button type="primary" size="small" @click="doSave">
        {{ dialogType == 'add' ? '保存' : '修改' }}
      </el-button>
      <el-button size="small" @click="doClose">取消</el-button>
    </div>
  </div>
</template>

<script>
import VUpload from '@/views/components/v-upload';

export default {
  components: { VUpload },
  props: ['rowData', 'dialogType', 'apis'],
  data() {
    return {
      // 表单数据
      formData: {
        title: '',
        content: '',
        attachList: [], // 附件列表
      },
      rules: {
        title: [
          { required: true, message: '请输入标题' },
          { min: 1, max: 100, message: '长度在 1 到 30 个字符' },
        ],
        content: [
          { required: true, message: '请输入说明' },
          { min: 1, max: 500, message: '长度在 1 到 200 个字符' },
        ],
        attachList: [{ required: true, message: '请上传文件' }],
      },
    };
  },
  created() {
    this.formData = Object.assign({}, this.formData, this.rowData);
  },
  methods: {
    doSave() {
      this.$refs.formRef.validate((valid) => {
        if (valid) {
          let fn = this.dialogType == 'add' ? this.apis.add : this.apis.update;
          fn(this.formData, {
            showLoading: { text: '处理中...' },
          }).then(() => {
            this.$message.success('操作成功!');
            this.$emit('update', true);
          });
        }
      });
    },
    doClose() {
      this.$emit('close');
    },
  },
};
</script>

<style lang="scss" scoped>
.dialog-root {
  /* 给按钮的父元素加一个相对定位，方便按钮的布局 */
  position: relative;
  /* 内容容器 */
  .container {
    position: relative;
    box-sizing: border-box;
    width: 100%;
    max-height: 60vh;
    padding: 0 10px;
    overflow: scroll;
  }
  /* 按钮占位区域 */
  .placeholder {
    height: 50px;
  }
  /* 底部固定的按钮区域 */
  .btn {
    position: absolute;
    bottom: 0;
    width: 100%;
    height: 50px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    background: #fff;
  }
}
</style>
